import { useState } from 'react';

/**
 * @function useToggle -  Hook is used for toggle boolean value.
 * @description It can be used for open and close of Modal, toggle buttons.
 * @param {boolean} defaultValue - Boolean value (true|false*).
 * @returns {Function} - returns toggle values
 * @property {boolean} value - returned toggle value
 * @property {Function} toggle - Function to toggle the value
 * @property {Function} enable - Function to set value to True
 * @property {Function} disable - Function to set value to False
 */
export const useToggle = (defaultValue = false) => {
  const [value, setToggle] = useState(defaultValue);
  return {
    value,
    /**
     *@function toggle - Function to toggle the value
     * @returns {Function} - Sets the toggle value
     */
    toggle: () => setToggle(!value),
    /**
     *@function enable - Function to enable toggle
     * @returns {Function} - Function to set value to True
     */
    enable: () => setToggle(true),
    /**
     *@function toggle - Function to disable toggle
     * @returns {Function} - Function to set value to False
     */
    disable: () => setToggle(false),
  };
};

export default useToggle;
